export enum ENGINE_ERROR {
    UNKNOWN = "Unknown error occurred",
    WEBGL_UNSUPPORTED = "WebGL must be supported to run tsthree",
    MULTIPLE_INSTANCE = "Only one Engine instance can be active at once!",
    NUM_OF_ERROR_CODES = "num_of_error_codes",
}
